<template>
    <div  :class="['layer', {
            availableLayer: availableLayer,
            active: showControls,
            topLevel: layer.toplevel
        }]"
          :id="'layer-' + id"
          ref="layer"
          :style="{'z-index': layer.toplevel ? 10000 : index,
            'pointer-events': notActiveClass || layer.toplevel ? 'none' : '',
            opacity: notActiveClass ? 0.3 : 1
          }"
          @click="activateLayer">
        <component :is="layer.type + 'Layer'"
                   :layer="layer"
                   :id="layer.id"
                    @clicked="$emit('editValue', $event)"/>
        <layer-controls :layerId="id"
                        @changeLayerIndex="changeLayerIndex"
                        @removeLayer="removeLayer"
                        v-if="showControls"/>
    </div>

</template>

<script type="text/babel">
import LayersMixin from '../../../../../mixins/LayersMixin.vue';

import LayerControls from './LayerControls.vue';
export default {
    name: 'WorkspaceLayer',
    data () {
        return {
            index: this.idx
        };
    },
    props: {
        availableLayer: {
            type: Boolean,
            default: false
        },
        id: {
            type: String
        },
        layer: {
            type: Object
        },
        showControls: {
            type: Boolean,
            default: false
        },
        idx: {
            type: Number
        },
        activeLayer: {
            type: Object
        }
    },
    mixins: [LayersMixin],
    components: {
        LayerControls
    },
    computed: {
        notActiveClass () {
            return (this.activeLayer.id && (this.activeLayer.id !== this.id)) && this.activeLayer.index <= this.index;
        }
    },
    methods: {
        activateLayer () {
            this.$emit('activated', this.id);
        },
        changeLayerIndex (val) {
            if (val.direction === 0) {
                this.index = 0;
            } else if (val.direction > 0){
                this.index = this.index + val.direction;
            } else if (val.direction < 0) {
                this.index = this.index > 0 ? this.index + val.direction : 0;
            }
        },
        removeLayer () {
            this.$emit('removeLayer', this.idx);
        },
        editValue (value) {
            value.attrs.style.height = '10%';
        }
    }
};

</script>
